import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=2d1d4b28&scoped=true"
import script from "./ImageBanner.vue?vue&type=script&lang=js"
export * from "./ImageBanner.vue?vue&type=script&lang=js"
import style0 from "./ImageBanner.vue?vue&type=style&index=0&id=2d1d4b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d4b28",
  null
  
)

export default component.exports